var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-loader",class:{'c-loader--visible': _vm.loading }},[_c('div',{staticClass:"c-loader__logo"},[_c('img',{staticClass:"c-loader__logo-rotating",attrs:{"src":require("../assets/logo.png"),"alt":"Waitress loading"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }